import type { IconProps } from 'iconsax-reactjs';

/**
 * A price gap: two candles with untraded space between them.
 *
 * Drawn rather than borrowed — a gap
 * is a specific market event and no general icon set has a glyph for it. The
 * closest stand-in was a bar-chart icon, which says "chart" and nothing about
 * a void in price.
 *
 * The two dashed rules are the gap's edges: the previous candle's close and the
 * next one's open, with the band no trade passed through between them. That is
 * exactly what the module draws on the chart, so the icon and the feature agree.
 */
export function GapIcon({ size = 24, color = 'currentColor', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* Lower candle, with its wick. */}
      <path d="M6.5 15.5V21" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <rect
        x="4"
        y="15.5"
        width="5"
        height="4"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />

      {/* Upper candle, opening above the gap. */}
      <path d="M17.5 3V8.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <rect
        x="15"
        y="8.5"
        width="5"
        height="4"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />

      {/* The untraded band: the two levels nothing changed hands between. */}
      <path
        d="M2.5 15.5H21.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="2.5 2.5"
      />
      <path
        d="M2.5 12.5H21.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="2.5 2.5"
      />
    </svg>
  );
}
